import clsx from 'clsx'
import PropTypes from 'prop-types'

import styles from './style.module.scss'

/**
 * Statuszeichen für Listen und Detailansichten.
 *
 * Vorher standen an diesen Stellen zwei PNG-Dateien (`warning.png`,
 * `checked.png`) — Emoji-Grafiken in fester Farbe und fester Auflösung. Hier
 * sind es Strich-SVGs in `currentColor`: Sie nehmen die Farbe des Textes
 * daneben an, bleiben in jeder Größe scharf und passen zu den übrigen Symbolen
 * der Anwendung.
 *
 * **Wichtig:** Die Breite steht als `flex: 0 0 <px>` am SVG. Global gilt
 * `svg { flex: 1 1 0% }`; ohne die eigene Angabe zieht sich das Zeichen in
 * einer Flex-Zeile auseinander (siehe SVG-Flex-Falle).
 */
const GLYPHS = {
	check: (
		<>
			<circle cx="12" cy="12" r="9" />
			<path d="m8.25 12.25 2.5 2.5 5-5.5" />
		</>
	),
	warning: (
		<>
			<path d="M12 4.75 2.9 19.25h18.2L12 4.75Z" />
			<path d="M12 10v4" />
			<path d="M12 17.15h.01" />
		</>
	),
	rejected: (
		<>
			<circle cx="12" cy="12" r="9" />
			<path d="m9.25 9.25 5.5 5.5" />
			<path d="m14.75 9.25-5.5 5.5" />
		</>
	),
	invited: (
		<>
			<rect x="3" y="5.25" width="18" height="13.5" rx="2.5" />
			<path d="m3.75 7.25 8.25 5.75 8.25-5.75" />
		</>
	),
	pending: (
		<>
			<circle cx="12" cy="12" r="9" />
			<path d="M12 7.25V12l3 1.75" />
		</>
	)
}

export default function StatusIcon({ name, size, className, title }) {
	const glyph = GLYPHS[name]
	if (!glyph) return null

	return (
		<svg
			className={clsx(styles.icon, className)}
			style={{ flex: `0 0 ${size}px`, width: size, height: size }}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth={1.8}
			strokeLinecap="round"
			strokeLinejoin="round"
			role="img"
			aria-label={title || undefined}
			data-tip={title || undefined}
		>
			{glyph}
		</svg>
	)
}

StatusIcon.propTypes = {
	name: PropTypes.oneOf(Object.keys(GLYPHS)).isRequired,
	size: PropTypes.number,
	className: PropTypes.string,
	/** Erklärung am Mauszeiger — dieselbe Beschriftung liest der Screenreader. */
	title: PropTypes.string
}

StatusIcon.defaultProps = {
	size: 18,
	className: '',
	title: ''
}
